<!--<b>VRIJGESTELDE WINSTBESTANDDELEN</b>-->
<!--<br/>-->
<!--Voor een aantal soorten winst geldt een vrijstelling. Bij de berekening van de belastbare winst worden deze-->
<!--vrijstellingen van de winst afgetrokken.-->
<!--<br/>-->
<!--Vul de vrijgestelde winstbestanddelen hier alleen in als deze zijn opgenomen in de resultatenrekening in-->
<!--deze aangifte.-->
<!--<br/><br/>-->
<!--Het gaat om de volgende vrijstellingen:<br/>-->
<!--<ul>-->
<!--    <li>Bosbouwvrijstelling.</li>-->
<!--    <li>Landbouwvrijstelling.</li>-->
<!--    <li>Vrijstelling voor kwijtscheldingswinst.</li>-->
<!--</ul>-->

<!--<b>Bosbouwvrijstelling</b><br/>-->
<!--De winst uit een bosbedrijf is vrijgesteld van belastingheffing. 'Bos' is daarbij een zeer ruim begrip.-->
<!--Bomen als wegbeplanting of de bomen rond een boerderij worden ook beschouwd als een bosbedrijf. Het-->
<!--bosbedrijf mag deel uitmaken van een meeromvattende onderneming.-->
<!--<br/>-->
<!--Omdat de winst uit een bosbedrijf is vrijgesteld, is geleden verlies ook niet aftrekbaar. Is er sprake van-->
<!--een verliesgevend bosbedrijf? Dan kun je de Belastingdienst vragen de vrijstelling niet toe te passen. Je mag-->
<!--het verlies dan aftrekken.-->
<!--<br/><br/>-->
<!--<b>Landbouwvrijstelling</b><br/>-->
<!--De landbouwvrijstelling geldt voor de positieve of negatieve waardeveranderingen van landbouwgronden die-->
<!--niet zijn ontstaan door de bedrijfsvoering of door bestemmingswijziging. Het landbouwbedrijf mag deel-->
<!--uitmaken van een meeromvattende onderneming. Bijvoorbeeld een onderneming met 2 verschillende activiteiten:-->
<!--landbouw en loonwerk.-->
<!--<br/><br/>-->
<!--<b>Vrijstelling voor kwijtscheldingswinst</b><br/>-->
<!--De vrijstelling voor kwijtscheldingswinst is een vrijstelling voor winst die ontstaat als een schuldeiser-->
<!--afziet van het innen van een schuld die de vennootschap bij de schuldeiser heeft. In dat geval levert dit de-->
<!--onderneming winst op. Deze winst is vrijgesteld onder de volgende voorwaarden:<br/>-->
<!--<ul>-->
<!--    <li>De schuld is niet te innen, bijvoorbeeld door een (dreigend) faillissement.</li>-->
<!--    <li>Van de winst die is behaald met de kwijtschelding is alleen het deel vrijgesteld dat hoger hoger is dan de-->
<!--        te verrekenen verliezen van vorige boekjaren en van het boekjaar zelf. Verliezen in boekjaren die volgen op-->
<!--        het boekjaar van de kwijtschelding, verkleinen het vrijgestelde bedrag niet.-->
<!--    </li>-->
<!--</ul>-->

<!--<b>Overige vrijgestelde winstbestanddelen</b>-->
<!--<br/>-->
<!--Naast de hiervoor vermelde vrijgestelde winstbedstanddelene zijn ook de volgende winstbestanddelen vrijgesteld :-->
<!--<br/>-->
<!--<ul>-->
<!--    <li>pensioenaanspraken volgens een verplichte bedrijfs- of beroepspensioenregeling.</li>-->
<!--    <li>vergoedingen voor bedrijfsbeëindiging.</li>-->
<!--    <li>bepaalde subsidies voor bos en natuur.</li>-->
<!--    <li>mobiliteitsprojectvrijstelling.</li>-->
<!--    <li>vrijstelling hinderbeperkingsprojecten.</li>-->
<!--</ul>-->

<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Vrijgestelde winstbestanddelen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor een aantal soorten winst geldt een vrijstelling. Bij de berekening van de belastbare winst worden
                deze
                vrijstellingen van de winst afgetrokken.
                <br/>
                Vul de vrijgestelde winstbestanddelen hier alleen in als deze zijn opgenomen in de resultatenrekening in
                deze aangifte.
                <br/><br/>
                Het gaat om de volgende vrijstellingen:<br/>
                <ul>
                    <li>de bosbouwvrijstelling.</li>
                    <li>de landbouwvrijstelling.</li>
                    <li>de vrijstelling voor kwijtscheldingswinst.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Bosbouwvrijstelling
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De winst uit een bosbedrijf is vrijgesteld van belastingheffing. 'Bos' is daarbij een zeer ruim begrip.
                Bomen als wegbeplanting of de bomen rond een boerderij worden ook beschouwd als een bosbedrijf. Het
                bosbedrijf mag deel uitmaken van een meeromvattende onderneming.
                <br/>
                Omdat de winst uit een bosbedrijf is vrijgesteld, is geleden verlies ook niet aftrekbaar. Is er sprake
                van
                een verliesgevend bosbedrijf? Dan kun je de Belastingdienst vragen de vrijstelling niet toe te passen.
                Je mag
                het verlies dan aftrekken.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Landbouwvrijstelling
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De landbouwvrijstelling geldt voor de positieve of negatieve waardeveranderingen van landbouwgronden die
                niet zijn ontstaan door de bedrijfsvoering of door bestemmingswijziging. Het landbouwbedrijf mag deel
                uitmaken van een meeromvattende onderneming. Bijvoorbeeld een onderneming met 2 verschillende
                activiteiten: landbouw en loonwerk.
                <br/><br/>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Vrijstelling voor kwijtscheldingswinst
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De vrijstelling voor kwijtscheldingswinst is een vrijstelling voor winst die ontstaat als een
                schuldeiser afziet van het innen van een schuld die de vennootschap bij de schuldeiser heeft. In dat
                geval levert dit de onderneming winst op. Deze winst is vrijgesteld onder de volgende voorwaarden:<br/>
                <ul>
                    <li>de schuld is niet te innen, bijvoorbeeld door een (dreigend) faillissement.</li>
                    <li>van de winst die is behaald met de kwijtschelding is alleen het deel vrijgesteld dat hoger hoger
                        is dan de te verrekenen verliezen van vorige boekjaren en van het boekjaar zelf. Verliezen in
                        boekjaren die volgen op het boekjaar van de kwijtschelding, verkleinen het vrijgestelde bedrag
                        niet.
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Overige vrijgestelde winstbestanddelen
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Naast de hiervoor vermelde vrijgestelde winstbedstanddelene zijn ook de volgende winstbestanddelen vrijgesteld :
                <br/>
                <ul>
                    <li>pensioenaanspraken volgens een verplichte bedrijfs- of beroepspensioenregeling.</li>
                    <li>vergoedingen voor bedrijfsbeëindiging.</li>
                    <li>bepaalde subsidies voor bos en natuur.</li>
                    <li>mobiliteitsprojectvrijstelling.</li>
                    <li>vrijstelling hinderbeperkingsprojecten.</li>
                </ul>
            </div>
        </div>
    </div>
</div>

